import React from 'react';
import { useUIStore } from '@/store/useUIStore';
import { TopBar } from '@/components/layout/TopBar';
import { LiveView } from '@/components/live/LiveView';
import { StoresView } from '@/components/stores/StoresView';
import { PipelineView } from '@/components/pipeline/PipelineView';
import { EconomyView } from '@/components/economy/EconomyView';
import { RulesView } from '@/components/rules/RulesView';
import { Gate } from '@/components/auth/Gate';
import { MobileApp } from '@/components/mobile/MobileApp';

const ViewMap: Record<string, React.ComponentType> = {
  live: LiveView,
  stores: StoresView,
  pipeline: PipelineView,
  economy: EconomyView,
  rules: RulesView,
};

export const App: React.FC = () => {
  const activeTab = useUIStore(s => s.activeTab);
  const ActiveView = ViewMap[activeTab] ?? LiveView;

  return (
    <Gate>
      {/* Mobile : expérience dédiée (onglets en bas) */}
      <div className="md:hidden h-full">
        <MobileApp />
      </div>
      {/* Desktop / tablette : QG complet */}
      <div className="hidden md:flex flex-col h-full bg-bg-base overflow-hidden">
        <TopBar />
        <main className="flex flex-1 overflow-hidden">
          <ActiveView />
        </main>
      </div>
    </Gate>
  );
};
